import React from "react";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import { toParticipantUiText } from "../../../../../../app/utils/participantTerminology";

const MilestoneItem = ({ milestoneLabel, comments, milestoneDateMillis }) => {
  return (
    <div
      style={{
        height: "auto",
        marginBottom: "10px",
        display: "flex",
        flexDirection: "column",
        gap: "0.7rem",
      }}
    >
      <Typography>
        <span style={{ color: "var(--text-primary)", fontWeight: "700" }}>
          {milestoneDateMillis === null
            ? "DD/MM/YYYY"
            : moment(milestoneDateMillis).utc().format("DD/MMM/YYYY")}
        </span>
        {` ${toParticipantUiText(milestoneLabel)}`}
      </Typography>
      {comments && (
        <Typography
          style={{ marginTop: "-.5rem", overflow: "auto", maxHeight: "100px" }}
        >
          <span style={{ color: "var(--text-primary)", fontWeight: "700" }}>
            Comments:{" "}
          </span>
          {comments}
        </Typography>
      )}
    </div>
  );
};

export default MilestoneItem;
